import {Component, OnInit} from '@angular/core';
import {BmCreditorCamtImportConfigBaseComponent} from "../bm-creditor-camt-import-config-base.component";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";

@Component({
    selector: 'bm-creditor-camt-import-config-full',
    templateUrl: 'bm-creditor-camt-import-config-full.component.html',
    standalone: false
})
export class BmCreditorCamtImportConfigFullComponent extends BmCreditorCamtImportConfigBaseComponent implements OnInit {

    configDetailWidgetData: WidgetData;

    ngOnInit() {
        super.ngOnInit();
        this.initWidgets();
    }

    initWidgets() {
        this.configDetailWidgetData = WidgetFactory.createWidgetEntityData(
            'bm.creditor.camt.import.config.detail',
            'CAMT Import Konfiguration',
            'bm.CreditorCamtImportConfig',
            this.objectIdentifier.objectId
        );
    }
}
